import { LoaderService } from 'app/services/loader.service';
import { GrupoParametroController } from './../../controllers/grl/grupo-parametro.controller';
import { Injectable } from '@angular/core';
import { GrupoParametro } from '@tivic-team/manager-ts/dist/grl/entities/grupo-parametro.entity';

@Injectable({
  providedIn: 'root'
})
export class GrupoParametroService {

  constructor(
    private _loaderService: LoaderService,
    private _controller: GrupoParametroController
  ) { }

  public async getAll(): Promise<Array<GrupoParametro>> {
    this._loaderService.show()
    return await this._controller.getAll().finally(() => this._loaderService.hide())
  }
}
